import axios from 'axios';

// 使用相对路径 → 通过 React dev server proxy 转发到后端
const API = axios.create({ baseURL: '/api' });

API.interceptors.request.use((req) => {
  const token = localStorage.getItem('token');
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  register: (data) => API.post('/auth/register', data),
  login: (data) => API.post('/auth/login', data),
};

export const profileAPI = {
  get: (userId) => API.get(`/profile/${userId}`),
  update: (userId, data) => API.put(`/profile/${userId}`, data),
};

export const langAPI = {
  list: () => API.get('/languages'),
};

export default API;
